// projects/humanresources-personnel/src/assets/i18n/*/hr-per-military.json
export class HrPerMilitaryKey {
    private static readonly keyPrefix = 'hrPerMilitary';
    public static title = `${HrPerMilitaryKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerMilitaryKey.keyPrefix}.pageHeader`;
    public static personnelNumber = `${HrPerMilitaryKey.keyPrefix}.personnelNumber`;
    public static personnelNameSurname = `${HrPerMilitaryKey.keyPrefix}.personnelNameSurname`;
    public static people = `${HrPerMilitaryKey.keyPrefix}.people`;
    public static object = `${HrPerMilitaryKey.keyPrefix}.object`;
    public static count = `${HrPerMilitaryKey.keyPrefix}.count`;
    public static postponedCompletedDate = `${HrPerMilitaryKey.keyPrefix}.postponedCompletedDate`;
    public static joinDateAsThirdLieutenant = `${HrPerMilitaryKey.keyPrefix}.joinDateAsThirdLieutenant`;
    public static joinDateAsSecondLieutenant = `${HrPerMilitaryKey.keyPrefix}.joinDateAsSecondLieutenant`;
    public static teacherCountry = `${HrPerMilitaryKey.keyPrefix}.teacherCountry`;
    public static teacherProvince = `${HrPerMilitaryKey.keyPrefix}.teacherProvince`;
    public static teacherSubprovince = `${HrPerMilitaryKey.keyPrefix}.teacherSubprovince`;
    public static teacherVillage = `${HrPerMilitaryKey.keyPrefix}.teacherVillage`;
    public static office = `${HrPerMilitaryKey.keyPrefix}.office`;
    public static rankCode = `${HrPerMilitaryKey.keyPrefix}.rankCode`;
    public static branchCode = `${HrPerMilitaryKey.keyPrefix}.branchCode`;
    public static garrisonJoinDate = `${HrPerMilitaryKey.keyPrefix}.garrisonJoinDate`;
    public static thirdLieutenantDate = `${HrPerMilitaryKey.keyPrefix}.thirdLieutenantDate`;
    public static dispatchDate = `${HrPerMilitaryKey.keyPrefix}.dispatchDate`;
    public static serviceNumber = `${HrPerMilitaryKey.keyPrefix}.serviceNumber`;
    public static noCountedDuration = `${HrPerMilitaryKey.keyPrefix}.noCountedDuration`;
    public static soldierDuration = `${HrPerMilitaryKey.keyPrefix}.soldierDuration`;
    public static addedTime = `${HrPerMilitaryKey.keyPrefix}.addedTime`;
    public static addedServiceYear = `${HrPerMilitaryKey.keyPrefix}.addedServiceYear`;
    public static addedServiceMonth = `${HrPerMilitaryKey.keyPrefix}.addedServiceMonth`;
    public static addedServiceDay = `${HrPerMilitaryKey.keyPrefix}.addedServiceDay`;
    public static borrowedTime = `${HrPerMilitaryKey.keyPrefix}.borrowedTime`;
    public static borrowedTimeYear = `${HrPerMilitaryKey.keyPrefix}.borrowedTimeYear`;
    public static borrowedTimeMonth = `${HrPerMilitaryKey.keyPrefix}.borrowedTimeMonth`;
    public static borrowedTimeDay = `${HrPerMilitaryKey.keyPrefix}.borrowedTimeDay`;
    public static forThirdLieutenantTeacher = `${HrPerMilitaryKey.keyPrefix}.forThirdLieutenantTeacher`;
    public static nonMilitaryPeriod = `${HrPerMilitaryKey.keyPrefix}.nonMilitaryPeriod`;
    public static timeInMilitaryService = `${HrPerMilitaryKey.keyPrefix}.timeInMilitaryService`;
}
